import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  q: '',
  page: 1,
  ref: '',
}

const indexSearchSchema = type({
  q: searchParamString.default(DEFAULT_VALUES.q),
  page: fallbackToDefault(type('number > 0'), DEFAULT_VALUES.page),
  ref: fallbackToDefault(searchParamString, DEFAULT_VALUES.ref),
})

export const Route = createFileRoute('/_shop/shop/')({
  validateSearch: indexSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES)],
  },
})
